module.exports = __webpack_public_path__ + "static/media/home-banner-illustration.a5175d7a.svg";